import { render } from "./UploadArea.vue?vue&type=template&id=0abc7e71&scoped=true"
import script from "./UploadArea.vue?vue&type=script&lang=js"
export * from "./UploadArea.vue?vue&type=script&lang=js"

import "./UploadArea.vue?vue&type=style&index=0&id=0abc7e71&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abc7e71"]])

export default __exports__